import formurlencoded from "form-urlencoded";
import { BASE_URL, BASE_URL_LEGACY } from "./";
import ReactGA from "react-ga4";

export const userService = {
  login,
  logout,
};

function login(username, password) {
  const obj = {
    username: username,
    password: password,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    credentials: "include",
    body: formurlencoded(obj), //`username=${username}&password=${password}`,
  };

  return (
    fetch(`${BASE_URL_LEGACY}/accounts/login/`, requestOptions)
      // fetch(`${BASE_URL}/accounts/login/`, requestOptions)

      .then((response) => {
        if (!response.ok) {
          return Promise.reject(response.statusText);
        }

        return response.json();
      })
      .then((detail) => {
        let user = {
          username: username,
          already_set_up: detail.already_set_up,
        };
        detail.dashboard.map((item) => {
          if (item.user_id) {
            user.user_id = item.user_id;
            user.user_title = item.title;
          }
          if (item.dependant_user_id) {
            user.dependant_user_id = item.dependant_user_id;
            user.dependant_title = item.title;
            user.num_alerts = item.num_alerts;
          }

          return true;
        });

        const sp_id = detail.dashboard.length > 1 && detail.dashboard[1].sp_id
          ? detail.dashboard[1].sp_id
          : detail.dashboard[0].sp_id;

        const house_id = detail.dashboard.length > 1 && detail.dashboard[1].user_house_id
          ? detail.dashboard[1].user_house_id
          : detail.dashboard[0].user_house_id;

        const user_id = detail.dashboard[0].user_id
          ? detail.dashboard[0].user_id
          : 0;
        const dependant_user_id = detail.dashboard.length > 1 && detail.dashboard[1].dependant_user_id
          ? detail.dashboard[1].dependant_user_id
          : 0;

        localStorage.setItem("CSRF", JSON.stringify(detail.csrftoken));
        localStorage.setItem("sp_id", JSON.stringify(sp_id));
        localStorage.setItem("house_id", JSON.stringify(house_id));
        localStorage.setItem("user_id", JSON.stringify(user_id));
        localStorage.setItem(
          "dependant_user_id",
          JSON.stringify(dependant_user_id)
        );

        setUpAnalytics();

        if (user) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          localStorage.setItem("user", JSON.stringify(user));
        }

        return user;
      })
  );
}

export function getGAData() {
  return {
    service_provider_id: JSON.parse(
        localStorage.getItem("sp_id") !== 'undefined'
            ? localStorage.getItem("sp_id")
            : null
    ),
    house_id: JSON.parse(
        localStorage.getItem("house_id") !== 'undefined'
            ? localStorage.getItem("house_id")
            : null
    ),
    ic_user_id: JSON.parse(
        localStorage.getItem("user_id") !== 'undefined'
            ? localStorage.getItem("user_id")
            : null
    ),
    caree_id: JSON.parse(
        localStorage.getItem("dependant_user_id") !== 'undefined'
            ? localStorage.getItem("dependant_user_id")
            : null
    ),
  };
}

export function setUpAnalytics() {
  ReactGA.gtag("set", "user_properties", getGAData());
}

function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie != "") {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) == name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function logout() {
  // remove user from local storage to log user out

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": getCookie("csrftoken"),
    },
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/accounts/logout/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((json) => {
      localStorage.removeItem("user");
    });
}

// function handleResponse(response) {
//   if (!response.ok) {
//     return Promise.reject(response.statusText);
//   }
//
//   return response.json();
// }
